<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import PositiveWaveLoop1 from '../../../assets/animations/energetic_frequencies/loops/positive_wave_loop_1.json'
import ArticleFull from './shared/ArticleFull.vue'

defineProps({
  item: Object,
})

const scheme = { backgroundColor: colors.q.cr.gray.primary, color: colors.q.cr.gray.darker }
</script>

<template>
  <ToFullTopLeft>
    <AnimatedBackground :lottie="PositiveWaveLoop1" :backgroundColor="scheme.backgroundColor" :color="scheme.color">
      <ArticleFull subtitle="Nu op Qmusic.nl" :title="item.enrichment.article.visualRadio.title" :imageUrl="item.enrichment.article.visualRadio.image">
        {{ item.enrichment.article.visualRadio.description }}
      </ArticleFull>
    </AnimatedBackground>
  </ToFullTopLeft>
</template>
